import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { ICheckable } from "@/Common/Models/UI/Inputs/ICheckable";

class PortalStatusCheckable implements ICheckable {
    public Id: string;
    public Name: string;
    public Checked: boolean;
    public Target: CheckboxTarget;
    public Visible: boolean = true;

    constructor(fields?: Partial<PortalStatusCheckable>) {
        (Object as any).assign(this, fields);
    }
}

export { PortalStatusCheckable };
